export class CreateUserController {

    constructor($state,UsersDao) {
        this.$state = $state;
        this.user = {};
        this.UsersDao = UsersDao;
    }

    create() {
        this.UsersDao.create(this.user).$promise.then((res)=>{
            if (res.data.success) {
                this.$state.go('login',{username: res.data.username});
            }
        });
    }

    userPasswordChanged() {
        this.errorMessage = null;
        if (this.user.password && this.user.password !== this.retypePassword) {
            this.errorMessage = "Passwords don't match"
        }
    }


}



// WEBPACK FOOTER //
// ./modules/xray/states/create_user/create_user.controller.js